<ng-template #mapTemplate>
  <p class="is-visually-hidden">
    {{'storelocator.a11y.mapNotAccessible' | translate}}
  </p>

  <a id="beforeMap" href="#skipMap" class="is-visually-hidden-focusable c__skip-links">
    {{'storelocator.a11y.skipMap' | translate}}
  </a>

  <sd-google-map #map
    [hasOffset]="!isPickup && !isEmbedded && !centerOnCountry"
    [brandColor]="googleMap.brandColor"
    [height]="googleMap.height"
    [width]="googleMap.width"
    [zoom]="googleMap.zoom"
    [center]="centerMap"
    [options]="googleMap.options"
    [markers]="googleMap.markers"
    [clusterOptions]="googleMap.clusterOptions"
    (markerClick)="markerClick($event)"
  />

  <a id="skipMap" href="#beforeMap" class="is-visually-hidden-focusable c__skip-links">
    {{'storelocator.a11y.backMap' | translate}}
  </a>
</ng-template>

<ng-template #filtersTemplate>
  <sd-store-filter-group
    [filters]="filters"
    [brand]="brand"
    (storeFiltered)="onStoreFiltered($event)"
  />
</ng-template>

<ng-template #searchTemplate>
  @if (!isPickup) {
    <sd-title [titleLevel]="locator.titleLevel" customClass="brand--h3">
      {{ title }}
    </sd-title>
  }
  @if (isPickup) {
    <span class="is-body-m c__find-pickup">
      {{ title }}
    </span>
  }
  @if (!!product) {
    <sd-product-card
      [isSSR]="false"
      [brand]="brand"
      [indexFollow]="product?.indexFollow !== undefined ? product?.indexFollow : true"
      [isSmall]="true"
      [horizontalLayout]="true"
      [hasAction]="false"
      (productSellerModal)="toggleProductSellerModal($event)"
      [productInfo]="product"
      (productClicked)="onProductClick($event)"
    />
  }
  <form novalidate>
    <sd-form-input
      #searchInput
      [labelTitle]="'storelocator.inputPlaceholder' | translate"
      [labelHidden]="true"
      [isFormAddon]="true"
      type="search"
      [placeholder]="'storelocator.inputPlaceholder' | translate"
      nameField="zipcode"
    />
    <button sd-button
      type="button"
      [brand]="brand"
      [attr.title]="'storelocator.a11y.locateMe' | translate"
      [isIcon]="true"
      [icon]="locator.button.icon"
      (click)="searchByUserPosition()"
    >
      <span class="is-visually-hidden">{{ 'storelocator.a11y.locateMe' | translate }}</span>
    </button>
  </form>
  @if (isPickup) {
    <div class="c__near-point">{{'checkout.shipping.nearPoint.find'| translate}}</div>
    <div>{{searchWord}}</div>
  }
</ng-template>

<ng-template #cardStoreTemplate>
  <ul>
    @for (store of filteredStores; track store) {
      <li><ng-container *ngTemplateOutlet="cardTemplate; context: { $implicit: store }" /></li>
    }
  </ul>
  <ng-template #cardTemplate let-item>
    <sd-card-store #storeCard
      [brand]="brand"
      [titleLevel]="locator.titleLevelCard"
      [color]="item.color"
      [repairCenter]="repairCenter"
      [hideActions]="hideCardActions"
      [pickup]="isPickup"
      [hasProduct]="!!product"
      [isHob]="isHob"
      (repairCenterSelected)="repairCenterClicked(item)"
      (storeClicked)="storeClick(storeCard)"
      (storeChoosed)="confirmChoice(item)"
      [storeInfo]="item"
      [itinaryUrl]="itineraryUrl"
      [buttonText]="mapSelectAction"
      [selectedPickupId]="selectedPickupId"
      (itenaryClicked)="itenaryClick()"
      (learnMoreClicked)="learnMoreClick()"
    />
  </ng-template>
</ng-template>

@if (!isMobile$ && !isEmbedded) {
  <ng-container *ngTemplateOutlet="mapTemplate" />
}

<div class="c__content-wrapper">
  <sd-map-legend
    class="{{!isPickup && !isMobile$ && !isEmbedded ? '' : 'is-visually-hidden'}}"
    [legends]="mapLegend"
  />
  @if (isMobile$ || isEmbedded) {
    <div class="c__search-container">
      <ng-container *ngTemplateOutlet="searchTemplate" />
      @if (filters?.length > 0 && !isPickup && !isCheckout) {
        <div class="c__stores-filters">
          <ng-container *ngTemplateOutlet="filtersTemplate" />
        </div>
      }
      @if (stores.length) {
        <p aria-live="polite" aria-atomic="true" class="is-visually-hidden">
          {{stores.length}} {{stores.length > 1 ? 'storelocator.storesFound' : 'storelocator.storeFound'}}
        </p>
      }
    </div>
    <sd-tab-group (selectedTabIndexChange)="scrollToActive($event)" [brand]="brand">
      <sd-tab>
        <ng-container sd-tab-title>
          <span>{{'storelocator.pickup.list' | translate}}</span>
        </ng-container>
        <div class="c__tab-pane is-list" sd-tab-pane>
          <div class="c__locator">
            <div class="c__content">
              @if (isLoading) {
                <div sd-loader [loading]="isLoading" [brand]="brand"></div>
              }
              @if (hasNoResults) {
                <p class="c__stores-no-results">
                  {{'storelocator.noResults' | translate}}
                </p>
              }
            </div>
            @if (stores?.length && !hasNoResults) {
              <div class="c__stores" #storesDiv>
                <ng-container *ngTemplateOutlet="cardStoreTemplate" />
              </div>
            }
          </div>
        </div>
      </sd-tab>
      <sd-tab>
        <ng-container sd-tab-title>
          <span>{{'storelocator.pickup.map' | translate}}</span>
        </ng-container>
        <div class="c__tab-pane is-map" sd-tab-pane>
          <sd-map-legend
            class="{{!isPickup && (isMobile$ || isEmbedded) ? '' : 'is-visually-hidden'}}"
            [legends]="mapLegend"
          />
          @if (currentSelectedCard) {
            <sd-card-store
              #mapStoreCard
              [brand]="currentSelectedCard.brand"
              [titleLevel]="locator.titleLevelCard"
              [color]="currentSelectedCard.color"
              [repairCenter]="repairCenter"
              [hideActions]="hideCardActions"
              [pickup]="isPickup"
              [hasCloseButton]="true"
              [hasProduct]="!!product"
              [storeInfo]="currentSelectedCard.storeInfo"
              [itinaryUrl]="currentSelectedCard.itinaryUrl"
              [buttonText]="mapSelectAction"
              [selectedPickupId]="selectedPickupId"
              (repairCenterSelected)="repairCenterClicked(currentSelectedCard.storeInfo)"
              (storeChoosed)="confirmChoice(currentSelectedCard.storeInfo)"
              (closeCard)="storeClick(mapStoreCard, true)"
            />
          }
          <ng-container *ngTemplateOutlet="mapTemplate" />
        </div>
      </sd-tab>
    </sd-tab-group>
  }

  @if (!isMobile$ && !isEmbedded) {
    <div class="c__locator">
      <div class="c__content c--panel">
        <div class="c__search-container">
          <ng-container *ngTemplateOutlet="searchTemplate" />
          @if (filters?.length > 0 && !isPickup && !isCheckout) {
            <div class="c__stores-filters">
              <ng-container *ngTemplateOutlet="filtersTemplate" />
            </div>
          }
          @if (isLoading) {
            <div sd-loader [loading]="isLoading" [brand]="brand"></div>
          }
          @if (hasNoResults) {
            <p class="c__stores-no-results">
              {{'storelocator.noResults' | translate}}
            </p>
          }
          @if (stores.length) {
            <p aria-live="polite" aria-atomic="true" class="is-visually-hidden">
              {{filteredStores.length}} {{(filteredStores.length > 1 ? 'storelocator.storesFound' : 'storelocator.storeFound') | translate}}
            </p>
          }
        </div>
      </div>
      @if (stores?.length && !hasNoResults) {
        <div class="c__stores" #storesDiv>
          <ng-container *ngTemplateOutlet="cardStoreTemplate" />
        </div>
      }
    </div>
  }
</div>
